module.exports = __webpack_public_path__ + "img/group-cx@3x.3d4e3118.png";